import { selector } from 'recoil'
import { cartState, configState } from './atoms'
import { ICartDictionary, ICartStats, IConfig, IProduct } from '@engyalo/storefront-types/lib/plugins/model'

export const hasCustomUnitType = (cartItem: IProduct) =>
  Array.isArray(cartItem.metadata?.unitTypes) && cartItem.metadata?.unitTypes.length > 0 && !!cartItem?.sizeDescription

export const DEFAULT_PRODUCT_WITH_UNIT_TYPE_QUANTITY = 1

export const cartStatsState = selector({
  key: 'cartStatsState',
  get: ({ get }) => {
    const cart = get(cartState)
    const totalNum = Object.keys(cart).reduce((acc, value) => {
      const cartItem = cart[value]
      const quantity = hasCustomUnitType(cartItem) ? DEFAULT_PRODUCT_WITH_UNIT_TYPE_QUANTITY : cartItem.quantity
      if (quantity) {
        return acc + quantity
      }
      return acc
    }, 0)
    const totalPrice =
      Object.keys(cart).reduce((acc, value) => {
        const price = cart[value].totalPrice || 0
        if (price > 0) {
          const quantity = cart[value].quantity
          if (quantity) {
            return acc + quantity * price
          }
        }
        return acc
      }, 0) || 0

    return {
      totalNum,
      totalPrice,
    } as ICartStats
  },
})

export const hasFetchedPreloadedCustomizationsState = selector({
  key: 'hasFetchedPreloadedCustomizationsState',
  get: ({ get }) => {
    const { preloadedCart } = get<IConfig>(configState)
    const cart = get<ICartDictionary>(cartState)
    const hasProductsWithPreloadedCustomizations = () =>
      preloadedCart?.some(({ cartId }) => cartId.split('_').length > 0)
    const areAllCartItemsWithCompleteData = () =>
      Object.entries(cart).every(([cartId, product]) => {
        const [, customizations] = cartId.split('_')
        const hasCustomizations = !!product?.customizations

        if (!customizations) {
          return true
        }

        return customizations && hasCustomizations
      })
    return hasProductsWithPreloadedCustomizations() && areAllCartItemsWithCompleteData()
  },
})

export const producstWithPreloadedCustomizationsState = selector({
  key: 'producstWithPreloadedCustomizationsState',
  get: ({ get }) => {
    const { preloadedCart } = get<IConfig>(configState)
    return preloadedCart?.reduce((prev, { cartId }) => {
      const [product, customizations] = cartId.split('_')

      if (customizations) {
        return [...prev, product]
      }

      return prev
    }, [] as string[])
  },
})
